import { createFileRoute } from '@tanstack/react-router';

import SlideFormModal from '../../../-components/SlideFormModal';

export const Route = createFileRoute('/_authenticated/slideshows/$id/_content/slides/$slideId')({
    component: SlideFormModal,
});
